var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExerciseSpeaking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_725_1553)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.3,
    stroke: "url(#paint0_linear_725_1553)",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_725_1553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7885 9.52544C10.7885 6.69468 13.1217 4.3999 15.9999 4.3999C18.6666 4.3999 20.8655 6.36985 21.1743 8.91083L20.1434 9.29102L19.5444 9.43832C18.684 9.64986 17.7802 9.61572 16.9389 9.33991L16.8087 9.29721C16.3776 9.15586 15.9116 9.38502 15.7678 9.80905C15.6241 10.2331 15.8571 10.6914 16.2883 10.8327L16.4185 10.8754C17.5567 11.2486 18.7795 11.2948 19.9435 11.0086L20.6335 10.8389L21.2113 10.6258V12.2292L20.1756 12.5203L19.3251 12.7294C18.5826 12.912 17.8058 12.912 17.0633 12.7294L16.1995 12.517C15.7586 12.4086 15.3118 12.6723 15.2016 13.1059C15.0914 13.5395 15.3594 13.9789 15.8003 14.0873L16.6641 14.2997C17.6687 14.5467 18.7197 14.5467 19.7242 14.2997L20.6013 14.084L21.2108 13.9127C21.1722 16.7107 18.854 18.9672 15.9999 18.9672C13.1217 18.9672 10.7885 16.6724 10.7885 13.8417V9.52544Z",
    fill: "url(#paint1_linear_725_1553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22276 13.0324C7.67721 13.0324 8.04562 13.3947 8.04562 13.8417C8.04562 18.1623 11.6069 21.6649 15.9999 21.6649C20.3929 21.6649 23.9542 18.1623 23.9542 13.8417C23.9542 13.3947 24.3226 13.0324 24.777 13.0324C25.2315 13.0324 25.5999 13.3947 25.5999 13.8417C25.5999 18.7836 21.7395 22.8388 16.8228 23.2493V25.6606C17.0602 25.6914 17.2963 25.7355 17.53 25.7929L18.3938 26.0053C18.8346 26.1137 19.1027 26.5531 18.9925 26.9867C18.8823 27.4203 18.4355 27.684 17.9946 27.5756L17.1308 27.3632C16.7596 27.2719 16.3797 27.2262 15.9999 27.2262C15.6201 27.2262 15.2403 27.2719 14.869 27.3632L14.0052 27.5756C13.5643 27.684 13.1175 27.4203 13.0073 26.9867C12.8971 26.5531 13.1652 26.1137 13.606 26.0053L14.4699 25.7929C14.7035 25.7355 14.9396 25.6914 15.177 25.6606V23.2493C10.2603 22.8388 6.3999 18.7836 6.3999 13.8417C6.3999 13.3947 6.76831 13.0324 7.22276 13.0324Z",
    fill: "url(#paint2_linear_725_1553)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_725_1553",
    x: -23.8,
    y: -23.8,
    width: 79.6001,
    height: 79.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_1553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_725_1553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_725_1553",
    x: -17.6001,
    y: -19.6001,
    width: 67.2,
    height: 71.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_1553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_725_1553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_725_1553",
    x1: 1.19995,
    y1: 1.19995,
    x2: 30.815,
    y2: 30.7849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_725_1553",
    x1: 16.1616,
    y1: 32.5425,
    x2: 47.4994,
    y2: 7.12001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_725_1553",
    x1: 16.1616,
    y1: 32.5425,
    x2: 47.4994,
    y2: 7.12001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExerciseSpeaking);
export default __webpack_public_path__ + "static/media/exercise-speaking.0dcbe7720881a829f0e7e4ac9ef44e20.svg";
export { ForwardRef as ReactComponent };